export function resolveAcademicRecord(config) {
    const declared = config?.academicRecord;
    return {
        mode: declared?.mode ?? 'courses',
        imported: declared?.imported ?? false,
    };
}
/** ¿El seminario lleva el expediente por credenciales? */
export const usesCredentialRecord = (config) => resolveAcademicRecord(config).mode === 'credentials';
//# sourceMappingURL=academic-record.js.map